/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecurringTaskDefinitionDto
 */
export interface RecurringTaskDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    scheduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    dimensionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecurringTaskDefinitionDto
     */
    evidenceRequired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RecurringTaskDefinitionDto
     */
    slaHours?: number;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof RecurringTaskDefinitionDto
     */
    definitionVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    previousDefinitionId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskDefinitionDto
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskDefinitionDto
     */
    effectiveTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskDefinitionDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskDefinitionDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskDefinitionDto
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the RecurringTaskDefinitionDto interface.
 */
export function instanceOfRecurringTaskDefinitionDto(value: object): value is RecurringTaskDefinitionDto {
    return true;
}

export function RecurringTaskDefinitionDtoFromJSON(json: any): RecurringTaskDefinitionDto {
    return RecurringTaskDefinitionDtoFromJSONTyped(json, false);
}

export function RecurringTaskDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringTaskDefinitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'evidenceRequired': json['evidenceRequired'] == null ? undefined : json['evidenceRequired'],
        'slaHours': json['slaHours'] == null ? undefined : json['slaHours'],
        'status': json['status'] == null ? undefined : json['status'],
        'definitionVersion': json['definitionVersion'] == null ? undefined : json['definitionVersion'],
        'previousDefinitionId': json['previousDefinitionId'] == null ? undefined : json['previousDefinitionId'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'effectiveTo': json['effectiveTo'] == null ? undefined : (new Date(json['effectiveTo'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function RecurringTaskDefinitionDtoToJSON(json: any): RecurringTaskDefinitionDto {
    return RecurringTaskDefinitionDtoToJSONTyped(json, false);
}

export function RecurringTaskDefinitionDtoToJSONTyped(value?: RecurringTaskDefinitionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'scheduleId': value['scheduleId'],
        'initiativeId': value['initiativeId'],
        'dimensionId': value['dimensionId'],
        'evidenceRequired': value['evidenceRequired'],
        'slaHours': value['slaHours'],
        'status': value['status'],
        'definitionVersion': value['definitionVersion'],
        'previousDefinitionId': value['previousDefinitionId'],
        'effectiveFrom': value['effectiveFrom'] == null ? undefined : ((value['effectiveFrom']).toISOString()),
        'effectiveTo': value['effectiveTo'] == null ? undefined : ((value['effectiveTo']).toISOString()),
        'notes': value['notes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
    };
}

